import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { environment } from '@environment';
import { TranslateService } from '@ngx-translate/core';
import { CreateOrEditPendencyDialogComponent } from './components/create-or-edit-pendency-dialog/create-or-edit-pendency-dialog.component';
import { UpdateAssigneeModalComponent } from './components/update-assignee-modal/update-assignee-modal.component';
import { PendenciesService } from './service/pendencies.service';
var PendenciesComponent = /** @class */ (function () {
    function PendenciesComponent(matDialog, translateService, pendenciesService, authenticationService) {
        this.matDialog = matDialog;
        this.translateService = translateService;
        this.pendenciesService = pendenciesService;
        this.authenticationService = authenticationService;
        this.take = 10;
        this.after = null;
        this.pendenciesPage = null;
        this.enableLoadMoreButton = false;
        this.isLoading = false;
        this.isLoadingPendencies = false;
        this.permissions = {
            canCreate: this.authenticationService.hasPermission('pendencies-create'),
            canEdit: this.authenticationService.hasPermission('pendencies-edit'),
        };
    }
    PendenciesComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.isLoading = true;
                        where = {
                            maintenanceIds: [this.maintenance.id]
                        };
                        _a = this;
                        return [4 /*yield*/, this.pendenciesService.getPendencies({
                                where: where,
                                take: this.take,
                                after: this.after
                            })];
                    case 1:
                        _a.pendenciesPage = _b.sent();
                        this.isLoading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    PendenciesComponent.prototype.openCreatePendencyDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dialogRef = this.matDialog.open(CreateOrEditPendencyDialogComponent, {
                            panelClass: ['field-dialog-860'],
                            data: this.maintenance
                        });
                        return [4 /*yield*/, dialogRef.afterClosed().toPromise()];
                    case 1:
                        result = _a.sent();
                        if (!result || !result.pendency || !result.pendency.createPendency) {
                            return [2 /*return*/];
                        }
                        this.pendenciesPage.items.push(result.pendency.createPendency);
                        this.pendenciesPage.items.sort(function (a, b) { return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(); });
                        this.pendenciesPage.totalCount++;
                        if (!this.pendenciesListElement || !this.pendenciesListElement.nativeElement) {
                            return [2 /*return*/];
                        }
                        this.pendenciesListElement.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
                        return [2 /*return*/];
                }
            });
        });
    };
    PendenciesComponent.prototype.updateAssignee = function (id, assignee) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef, result, pendency;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dialogRef = this.matDialog.open(UpdateAssigneeModalComponent, {
                            data: {
                                id: id,
                                assignee: assignee
                            },
                            panelClass: ['update-assignee-modal'],
                        });
                        return [4 /*yield*/, dialogRef.afterClosed().toPromise()];
                    case 1:
                        result = _a.sent();
                        if (!result || !result.pendency) {
                            return [2 /*return*/];
                        }
                        pendency = this.pendenciesPage.items.find(function (findPendency) { return findPendency.id === id; });
                        pendency.assignee = result.pendency.assignee;
                        pendency.updatedAt = result.pendency.updatedAt;
                        this.pendenciesPage.items.sort(function (a, b) { return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(); });
                        return [2 /*return*/];
                }
            });
        });
    };
    PendenciesComponent.prototype.loadMorePendencies = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var where, newPendenciesPage, scrollPosition;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isLoadingPendencies = true;
                        where = {
                            maintenanceIds: [this.maintenance.id]
                        };
                        return [4 /*yield*/, this.pendenciesService.getPendencies({
                                where: where,
                                take: this.take,
                                after: this.pendenciesPage.pageInfo.endCursor
                            })];
                    case 1:
                        newPendenciesPage = _a.sent();
                        this.pendenciesPage.items = tslib_1.__spread(this.pendenciesPage.items, newPendenciesPage.items);
                        this.isLoadingPendencies = false;
                        this.enableLoadMoreButton = false;
                        scrollPosition = this.pendenciesListElement.nativeElement.clientHeight / 2;
                        this.pendenciesListElement.nativeElement.scrollTo({ top: scrollPosition, behavior: 'smooth' });
                        return [2 /*return*/];
                }
            });
        });
    };
    PendenciesComponent.prototype.redirectToPendencyDetails = function (id) {
        window.location.href = environment.MOUNTDOOM_2_URL + "/#/pendencias/" + id;
    };
    PendenciesComponent.prototype.getTooltipText = function (pendency) {
        if (!this.permissions.canEdit) {
            return this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.TOOLTIPS.PERMISSION_BLOCK_ASSIGNEE');
        }
        if (pendency.status === 'done') {
            return this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.TOOLTIPS.BLOCK_ASSIGNEE');
        }
        if (pendency.assignee) {
            return this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.TOOLTIPS.ASSIGNEE', { assigneeName: pendency.assignee.name });
        }
        return this.translateService.instant('MAINTENANCES.TABS.PENDENCIES.TOOLTIPS.NO_ASSIGNEE');
    };
    PendenciesComponent.prototype.onScroll = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var target, scrollPosition, hasMorePendencies;
            return tslib_1.__generator(this, function (_a) {
                target = event.target;
                scrollPosition = target.scrollTop + target.clientHeight;
                hasMorePendencies = this.pendenciesPage.totalCount > this.pendenciesPage.items.length;
                if (scrollPosition >= target.scrollHeight && hasMorePendencies) {
                    this.enableLoadMoreButton = true;
                    return [2 /*return*/];
                }
                this.enableLoadMoreButton = false;
                return [2 /*return*/];
            });
        });
    };
    return PendenciesComponent;
}());
export { PendenciesComponent };
